import { ICON_COLOR } from '../../../Icon'

export function getSelectDropdownEntityListItemIconProps({
  iconProps,
  isActive,
  isIconFollowingHover,
}) {
  return isIconFollowingHover && isActive
    ? { ...iconProps, color: ICON_COLOR.ButtonBg }
    : iconProps
}
